<template>
  <div class="col-sm-12">
    <div :id="chartId" class="container-chart survey-chart"></div>
  </div>
</template>

<script>
import * as d3 from 'd3'
import d3Tip from 'd3-tip'
import { GradientDistributionChart } from '../../utils/charts/GradientDistributionChart'
import Rainbow from 'rainbowvis.js'

export default {
  name: 'GradientDistributionChart',
  data() {
    return {
      dataset: {},
      sortedDataset: {},
      checked: [],
      chart: null,
      loading: true,
      chartWidth: 960,
      chartHeight: 500,
    }
  },
  props: ['config', 'chartId', 'site'],
  mounted() {
    d3.tip = d3Tip

    this.chart = new GradientDistributionChart(
      this.chartId,
      null,
      'bar',
      this.chartWidth,
      this.chartHeight,
      null,
      this.$t,
      this.site,
    )
    this.chart.initContainer(this.chartId)
    this.chart.initTooltip([])

    this.displayData()
  },
  watch: {
    config: {
      handler: function(config) {
        if (config) {
          this.displayData()
        }
      },
      immediate: false,
    },
  },
  methods: {
    displayData: function() {
      this.dataset = JSON.parse(JSON.stringify(this.config))
      this.processData()
      this.displayChart()
    },
    processData: function() {
      this.otherCategories = []
      this.dataset.items.push({
        category: this.$t('others'),
        count: 0,
        percent: 0,
      })

      //Filter small values in an "other" category (count and percent)
      let totalCount = 0
      this.dataset.items.forEach(item => {
        totalCount += item.count
        if (
          item.percent < 0.0 &&
          String(item.category) != '' &&
          String(item.category) != this.$t('others')
        ) {
          this.dataset.items[this.dataset.items.length - 1].count += item.count
          this.otherCategories.push(item)
        }
      })
      this.dataset.items[this.dataset.items.length - 1].percent = Math.round(
        (this.dataset.items[this.dataset.items.length - 1].count / totalCount) * 100,
      )

      //Filter and sortdataset items
      if (this.otherCategories.length > 2) {
        this.dataset.items = this.dataset.items.filter(item => {
          if (
            (item.percent >= 0.0 || String(item.category) == this.$t('others')) &&
            String(item.category) != ''
          ) {
            return item
          }
        })
      }

      if (
        this.dataset.items[this.dataset.items.length - 1].count == 0 ||
        this.otherCategories.length <= 2
      ) {
        this.dataset.items.splice(this.dataset.items.length - 1, 1)
      }

      if (this.isBarChart()) {
        this.dataset.items.sort((a, b) => {
          return a.category - b.category
        })
      } else {
        this.dataset.items.sort((a, b) => {
          return b.count - a.count
        })
      }

      this.otherCategories.sort((a, b) => {
        return b.count - a.count
      })

      this.sortedDataset = JSON.parse(JSON.stringify(this.dataset))
      this.checked = this.dataset.items.map(item => {
        return item.category
      })

      if (this.chart) {
        this.chart.setSite(this.site)
        this.chart.setConfig(this.config)
        this.chart.setDataset(this.dataset)
        this.chart.setSortedDataset(this.sortedDataset)
        this.chart.setChecked(this.checked)

        //const Rainbow = require('rainbowvis.js');
        let colorRainbow = new Rainbow()
        //colorRainbow.setSpectrum("#FFF858", "#FF6B6B");
        colorRainbow.setSpectrum('#92F19E', '#EDF580', '#FD8479')
        colorRainbow.setNumberRange(0, 8)

        let colorSet = []

        for (let i = 0; i <= this.dataset.items.length; i++) {
          colorSet.push('#' + colorRainbow.colorAt(i))
        }

        colorSet.push('#5AD8FB')

        this.chart.setColorsSet(colorSet)
      }
    },
    displayChart: function() {
      if (this.chart) {
        d3.select('#' + this.chartId + ' svg').remove()
        this.chart.initContainer(this.chartId)
        this.chart.initTooltip(this.otherCategories)
        this.chart.draw()
      }
    },
    isBarChart: function() {
      return this.dataset.answer_type == 'Slider' || this.dataset.answer_type == 'Rating'
    },
  },
}
</script>

<style scoped>
.bar-chart-gradient-axis text {
  font-size: xx-small !important;
}
</style>
